<template>
  <div>
    <MasterLayout>
      <div class="dashboard_first_row">
        <div class="pt-5 pb-3">
          <h3>{{ $t("text.bBankAccounts.inventoryReport") }}</h3>
        </div>

        <!-- DATE RANGE -->
        <!-- <div class="buttons_section">
           
          <div>
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :custom-shortcuts="customShortcuts"
              color="#4b2c72"
              format="DDMMYYYY"
              formatted="DD/MM/YYYY"
              label="Select a date range"
            />
          </div>
       
        </div> -->
      </div>
      <section>
        <div class="pos_table">
          <div class="row top_section_row" v-show="!showLoader">
            <div class="col-md-8">
              <!-- <span class="sec_text_color">
                Inventory Transaction between {{ startDate }} and {{ endDate }}
              </span> -->
              <span> </span>
            </div>
            <div class="col-md-4 text-right"></div>
          </div>
          <ejs-grid
            v-show="!showLoader"
            ref="dataGrid"
            :created="refreshGrid"
            :allowPaging="true"
            :allowSorting="true"
            :toolbar="toolbar"
            :pageSettings="pageSettings"
            :searchSettings="search"
            :allowExcelExport="true"
            :allowPdfExport="true"
            :toolbarClick="toolbarClick"
            :rowDataBound="rowDataBound"
            :allowTextWrap="true"
            :excelQueryCellInfo="excelQueryCellInfo"
            :locale="usedLang"
          >
            <e-columns>
              <e-column
                width="80"
                field="index"
                :allowSorting="false"
                headerText="#"
              ></e-column>
              <e-column
                field="tankName"
                width="200"
                :headerText="$t('text.tankReport.tankName')"
              ></e-column>
              <e-column
                field="product"
                width="150"
                :headerText="$t('text.form.product')"
              ></e-column>
              <e-column
                field="tankCapacity"
                format="N2"
                width="180"
                :headerText="$t('text.tanks.tankCapacity')"
              ></e-column>

              <e-column
                field="currentVolume"
                width="180"
                :headerText="$t('text.cDashboard.curVolume')"
              ></e-column>

              <e-column
                field="lastFilledDate"
                width="300"
                :headerText="$t('text.bBankAccounts.lastFilledDate')"
              ></e-column>

              <e-column
                field="lastFilledVolume"
                width="200"
                :headerText="$t('text.bBankAccounts.lastFilledVolume')"
              ></e-column>

              <e-column
                field="avgProductDispensePerDay"
                width="220"
                :headerText="$t('text.bBankAccounts.avgProductDispensePerDay')"
              ></e-column>
            </e-columns>
          </ejs-grid>
        </div>

        <TableLoader :showLoader="showLoader" />
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import POSModal from "@/components/modals/POS/index";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "Inventory Report",
  components: {
    MasterLayout,
    TableLoader,
    POSModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy" },

      branch: null,
      branchId: null,

      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      showLoader: true,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  created() {
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;

    document.title = "Inventory Transaction:: Epump Retail Outlet";

    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Inventory Transaction:: ${branch.name} Retail Outlet`;
    });
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.getInventoryReport();
      }
    },
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.getInventoryReport();
        }
      }
    },
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Inventory Report.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].width = "40";
          this.$refs.dataGrid.getColumns()[1].width = "120";
          this.$refs.dataGrid.getColumns()[2].width = "80";
          this.$refs.dataGrid.getColumns()[3].width = "120";
          this.$refs.dataGrid.getColumns()[4].width = "120";
          this.$refs.dataGrid.getColumns()[5].width = "180";
          this.$refs.dataGrid.getColumns()[6].width = "140";
          this.$refs.dataGrid.getColumns()[7].width = "140";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    rowDataBound: function (args) {},
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    excelQueryCellInfo(args) {
      if (args.column.field == "paymentDate") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
    formatNumber(num) {
      return Number(num).toLocaleString();
    },
    getInventoryReport() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/InventoryReport/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;

          response.data.forEach((cur) => {
            cur.index = ++index;
            cur.currentVolume = this.formatNumber(cur.currentVolume);
            cur.lastFilledVolume = this.formatNumber(cur.lastFilledVolume);
            cur.tankCapacity = this.formatNumber(cur.tankCapacity);
            cur.avgProductDispensePerDay = this.formatNumber(
              cur.avgProductDispensePerDay
            );
            cur.lastFilledDate = cur.lastFilledDate
              ? this.$moment(cur.lastFilledDate).format(
                  "MMMM Do YYYY, h:mm:ss a"
                )
              : "---";
          });

          this.showLoader = false;
          grid.ej2Instances.setProperties({ dataSource: response.data });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    convertThousand(request) {
      // const formatter = new Intl.NumberFormat('en')
      // return formatter.format(request)
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    revertNumber(number) {
      return Number(number.replace(/[^0-9.]+/g, ""));
    },
  },
};
</script>
<style>
@media screen and (max-width: 602px) {
  .POSModal .v--modal-box.v--modal {
    margin: 0 auto;
    top: 112px !important;
    width: 90% !important;
    height: 500px !important;
    left: 0 !important;
    overflow: auto;
  }
  .POSModal .v--modal-box.v--modal {
    margin: 0 auto;
    /* top: 88px !important; */
    width: 90% !important;
    height: 379px !important;
    left: 0 !important;
    overflow: auto;
  }
  button.add_quick_fuel_btn {
    margin-bottom: 62px;
  }
}
</style>
